import ActivateTveDevice from '../../Components/ActivateTveDevice/ActivateTveDevice'
import Footer from '../../Components/Footer/Footer'
import Logo from '../../Components/Logo/Logo'
import { useEffect } from 'react'
import { ActivationScreenEvents, BrandName } from '../../Typescript'
import AppMeasurements from '../../Services/AppMeasurements'
import DatadogService from '../../Services/DatadogService'

function Main({ brandName }: { brandName: BrandName }) {
    useEffect(() => {
        AppMeasurements.start(ActivationScreenEvents.activationScreen)
        DatadogService.trackAction('activation_page_loaded')
    }, [])
    return (
        <div className="container">
            <Logo brandName={brandName} />
            <ActivateTveDevice brandName={brandName} />
            <Footer brandName={brandName} />
        </div>
    )
}

export default Main
